"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@material-ui/core");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const date_fns_tz_1 = require("date-fns-tz");
const date_fns_1 = require("date-fns");
const DueDateAuditTooltip = ({ dueDateFieldName, currentDate, extensionDates, ...props }) => {
    const classes = (0, core_1.makeStyles)((theme) => ({
        arrow: {
            color: theme.palette.common.black,
        },
        tooltip: {
            backgroundColor: theme.palette.common.black,
        },
    }));
    return (react_1.default.createElement(core_1.Tooltip, { arrow: true, classes: classes(), title: react_1.default.createElement(core_1.Box, { p: 1 },
            react_1.default.createElement("strong", { color: "inherit" },
                dueDateFieldName,
                "s period changed:"),
            react_1.default.createElement(core_1.Box, { style: { paddingTop: '4px', fontWeight: 400 } },
                "New Comment Deadline:",
                ' ',
                (0, date_fns_tz_1.format)((0, date_fns_tz_1.utcToZonedTime)((0, date_fns_1.fromUnixTime)(currentDate), process.env.REACT_APP_DEFAULT_TIMEZONE), 'MMM do, yyyy zzz'),
                react_1.default.createElement("br", null),
                "Original:",
                ' ',
                (0, date_fns_tz_1.format)((0, date_fns_tz_1.utcToZonedTime)((0, date_fns_1.fromUnixTime)(extensionDates[extensionDates.length - 1].fieldValue), process.env.REACT_APP_DEFAULT_TIMEZONE), 'MMM do, yyyy zzz'))), ...props }));
};
DueDateAuditTooltip.propTypes = {
    dueDateFieldName: prop_types_1.default.string.isRequired,
    currentDate: prop_types_1.default.any.isRequired,
    extensionDates: prop_types_1.default.array.isRequired,
};
exports.default = DueDateAuditTooltip;
